import {
    GET_ELEARNING_SKILLS_REQUEST,
    GET_ELEARNING_SKILLS_SUCCESS,
    GET_ELEARNING_SKILLS_FAILURE
} from '../actions';


const initialState = {};

const ElearningSkillsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ELEARNING_SKILLS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_ELEARNING_SKILLS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_ELEARNING_SKILLS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default ElearningSkillsReducer;